import React from 'react';
import PropTypes from 'prop-types';

import {connectAppEnv} from '../../../app/app-env';
import {frefFromRef} from '../../../lib/react/higher-order-components';
import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import OEIcon from '../../elements/oe-icon';
import OEButton from '../../elements/controls/oe-button';
import OEIconCodes from '../../../lib/oe-icon-codes';
import OEStdModalController from '../../modals/oe-std-modal-controller';
import OENotification from '../../../lib/notification/oe-notification';
import {OEViewType} from '../../../lib/oe-types';
import {OEManualViewPropTypes, OEManualViewConfigFactory, OEManualViewLinks, OEManualViewLinkType} from './oe-manual-view-model';
import {OEBlurLayer, OEBlurModalBackdropLayer} from '../oe-blur-layer';
import OEToolbox from '../../../lib/tools/oe-toolbox';
import LocalStorage from '../../../lib/tools/local-storage';
import OEPDFView from '../../elements/pdf-view/oe-pdf-view';
import OEPlyr from '../../elements/oe-plyr';
import {OEMediaViewerContentType, OEMediaViewerContent, OEMediaViewerDataSourceIntrinsic} from '../../media-viewer/oe-media-viewer-model';
import OEMediaViewerController from '../../media-viewer/oe-media-viewer-controller';

export class OEManualView extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.options = this.normalizeOptions(this.props.options);

        this.state = {
            options:                    this.options,
            strings: {
                title:                  '',
                download:               'Manual'
            }
        };

        this.onLanguageChanged = this.onLanguageChanged.bind(this);

        this.onRef = this.onRef.bind(this);

        this.renderAdditionalButtons = this.renderAdditionalButtons.bind(this);

        this.onOpenStateChanged = this.onOpenStateChanged.bind(this);
        this.onOptionsChanged = this.onOptionsChanged.bind(this);
        this.onDownloadBtnPressed = this.onDownloadBtnPressed.bind(this);
    }

    normalizeOptions(options)   {
        let ret = {link: OEManualViewLinks.app};
        if(typeof(options) === 'object')    Object.assign(ret, options);
        if(!Array.isArray(ret.links))   ret.links = undefined;
        return ret;
    }

    componentWillReceiveProps(nextProps) {
        if(!OEToolbox.shallowEqual(nextProps.config, this.props.config, true) || nextProps.title != this.props.title || nextProps.titleId != this.props.titleId)     {
            this.updateLanguage(nextProps);
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.onLanguageChanged);

        this.timeout = setTimeout(this.onTimeout.bind(this), 500);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.onLanguageChanged);

        if(this.timeout)    {
            clearTimeout(this.timeout);
            this.timeout = 0;
        }
    }

    onTimeout() {
        this.timeout = 0;

        if(!this.ref)   {
            this.timeoutCall = true;
            return;
        }

        let config = this.props.config;
        if(config.showAtStartUp && this.oe.isReady() && LocalStorage.getItem('dontShowHelpViewAtStartUp') !== 'true' && this.ref)   {
            this.ref.setOpen(true);
        }

        this.timeoutCall = false;
    }

    onLanguageChanged() {
        this.updateLanguage();
    }

    updateLanguage(props)   {
        if(!this.oe.isReady())  return;
        props = props || this.props;
        let si = this.oe.sharedInterface;

        //
        let link = {type: OEManualViewLinkType.none};

        if(this.options)  {
            const links = this.options.links ? this.options.links : props.config.links;
            if(links)   link = links.find(link => link.link === this.options.link) || link;
        }

        //
        let hasOptionTitle = this.options && typeof(this.options.title) === 'string';
        let title = hasOptionTitle ? this.options.title : (props.config ? props.config.title : undefined);
        let titleId = this.options && this.options.titleId ? this.options.titleId : (hasOptionTitle ? undefined : (props.config ? props.config.titleId : undefined));
        if(titleId) title = si.getLocalizedStringEnc(titleId);

        //
        let ref = typeof(link.ref) === 'string' ? link.ref : '';
        if(typeof(link.refId) === 'string')   ref = si.getLocalizedStringEnc(link.refId);
        
        //
        let stateUpdate = {
            strings: {
                title:                  title,
                download:               si.getLocalizedStringEnc('help_view_manual_download')
            }
        };

        if(link.type == OEManualViewLinkType.pdf)   {
            stateUpdate['pdfRef'] = ref;
        } else if(link.type == OEManualViewLinkType.youtube)   {
            stateUpdate['youtubeRef'] = ref;
        } else if(link.type == OEManualViewLinkType.video)   {
            stateUpdate['videoRef'] = 'app/oe/' + this.oe.Module.filePackagePathURL + ref;
        }

        this.setState(stateUpdate);
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            return;
        }

        this.updateLanguage();
    }

    onRef(ref)  {
        this.ref = ref;
        if(this.props.fref) this.props.fref(ref);
        if(ref && this.timeoutCall) this.onTimeout();
    }

    renderAdditionalButtons(props)  {
        return (
            <React.Fragment>
                <OEButton
                    className="btn download-btn"
                    onPressed={this.onDownloadBtnPressed}>
                    <OEIcon code={OEIconCodes.download} />
                </OEButton>
            </React.Fragment>
        );
    }

    renderContent(link) {
        if(!link)   return null;

        if(link.type === OEManualViewLinkType.pdf && this.state.pdfRef)    {
            return (
                <OEPDFView 
                    fileURL={this.state.pdfRef}
                    page={Math.max(typeof(link.page) === 'number' ? link.page : 1, 1)}
                    layoutToPageHeight={true}
                />
            );
        }

        if(link.type === OEManualViewLinkType.youtube && this.state.youtubeRef)    {
            return <OEPlyr src={this.state.youtubeRef}/>;
        }

        if(link.type === OEManualViewLinkType.video && this.state.videoRef)    {

            const dataSource = new OEMediaViewerDataSourceIntrinsic(new OEMediaViewerContent(OEMediaViewerContentType.video, this.state.videoRef, false, null, null, null, false));

            return (
                <div className="video-content">
                    <div className="aspect-container">
                        <div className="aspect-content-container">
                            <OEMediaViewerController
                                dataSource={dataSource}
                                showControlsWhenWindow={true}
                                showNextPrevButtons={false}
                            />
                        </div>
                    </div>
                </div>
            );
        }

        return null;
    }

    render() {
        let link = {type: OEManualViewLinkType.none};

        if(this.state.options)  {
            const links = this.state.options.links ? this.state.options.links : this.props.config.links;
            if(links)   link = links.find(link => link.link === this.state.options.link) || link;
        }

        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>

                <OEStdModalController
                    className="simple-header clear-backdrop flow-nav-modal manual-view center"
                    moduleId={this.props.moduleId}
                    title={this.state.strings.title}
                    isOpen={this.props.isOpen}
                    hasCloseBtn={true}
                    additionalButtons={link.type === OEManualViewLinkType.pdf && this.state.pdfRef ? this.renderAdditionalButtons : null}
                    onOpenStateChanged={this.onOpenStateChanged}
                    onOptionsChanged={this.onOptionsChanged}
                    onToggle={this.props.onToggle}
                    ref={this.onRef}
                >

                    {this.renderContent(link)}

                    <OEBlurModalBackdropLayer/>

                    <OEBlurLayer apply={true} ruleName={'blur-manual-view-modal-backdrop'} selector={'body .blur-by-manual-view'}/>

                </OEStdModalController>

            </React.Fragment>
        );
    }

    onOpenStateChanged(sender, isOpen)    {
        if(this.props.onOpenStateChanged)   this.props.onOpenStateChanged(sender, isOpen);

        if(!this.props.appComponent || !this.props.appComponent.uiLayer) return;
        this.props.appComponent.uiLayer.notificationCenter.post(OENotification.viewOpenStateChanged, {
            type: OEViewType.manual,
            isOpen: isOpen,
            sender: sender
        });
    }
    
    onOptionsChanged(sender, options)   {
        this.options = this.normalizeOptions(options);
        this.setState({options: this.options});
        this.updateLanguage();
    }

    onDownloadBtnPressed()  {
        let link = document.createElement('a');
        link.download = this.state.strings.download + '.pdf';
        link.href = this.state.pdfRef;
        link.click();
    }
}

OEManualView.defaultProps = {
    moduleId:                       '',
    config:                         OEManualViewConfigFactory.buildStdConfig(),
};

OEManualView.propTypes = {
    moduleId:                       PropTypes.string,
    config:                         OEManualViewPropTypes.config,
    options:                        OEManualViewPropTypes.options
};

//
export default frefFromRef(connectAppEnv((env) => { return {
    appComponent:                   env.component,
    config:                         env.config.module.uiLayerConfig.manualView
}})(OEManualView));